import { observable, action, computed } from "mobx";
import { Selection } from "../Selection";
import { SelectionType } from "../../helpers";
/**
* Market defines model for market object information
* @typedef Market
* @type {SelectionType}
* @property {id} Selection identifier
* @property {selections} Array of selections that are related to the current market
*/

export type MarketType = {
    id: string,
    type: SelectionType,
    typeId: string,
    name: string,
    selections: Selection[],
    eachWayText?: string
};

export class Market {
    id: string;

    type: SelectionType;
    typeId: string;

    name: string;

    @observable eachWayText?: string;

    @observable selections: Selection[];

    constructor(marketData: MarketType) {
        this.id = marketData.id;
        this.selections = marketData.selections;
        this.name = marketData.name;
        this.type = marketData.type;
        this.typeId = marketData.typeId;
        this.eachWayText = marketData.eachWayText;
    }

    @action.bound
    update(market: Market): void {
        this.name = market.name;
        this.id = market.id;
        this.type = market.type;

        let selections2remove: string[] = this.selections.map(m => m.id);

        let existingSelections: string[] = this.selections.map(m => m.id);
        for (let j: number = 0; j < market.selections.length; j++) {
            let selection2removeIndex: number = selections2remove.indexOf(market.selections[j].id);
            if (selection2removeIndex !== -1) {
                selections2remove.splice(selection2removeIndex, 1);
            }

            let existingSelectionIndex: number = existingSelections.indexOf(market.selections[j].id);
            existingSelectionIndex !== -1
                ? this.selections[existingSelectionIndex].update(market.selections[j])
                : this.selections.push(market.selections[j]);
        }

        /* istanbul ignore next */
        for (let i: number = 0; i < selections2remove.length; i++) {
            let existingMarketIndex: number = this.selections.map(s => s.id).indexOf(selections2remove[i]);
            this.selections.splice(existingMarketIndex, 1);
        }
    }

    @computed
    get isDisabled(): boolean {
        return this.selections.every(sel => sel.isDisabled === true);
    }
}